/**
 * @description: 仓库管理-采购进货
 * @author: ccy
 * @update: hwx
 * @update: lyr(22-02-10)
 */
<template>
	<div class="purchasing">
		<div class="purchase-list" v-show="!showdetail">
			<div class="row row-margin">
				<button type="button" class="btn btn-flat btn-middle btn-orange" @click="addPurchase">新增采购进货单</button>
			</div>
			<div class="row row-margin">
				<label class="list-label-2">时间:</label>
				<div class="col-md-3 list-time">
					<div @click="clearDate" ref="time">
						<input type="text" class="form-control laydate-icon" :value="startTime"> -
						<input type="text" class="form-control laydate-icon" :value="endTime">
					</div>
				</div>
				<label class="list-label-4">门店名称:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" ref="shop" data-placeholder="请选择门店"></select>
				</div>
				<label class="list-label-2">仓库:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" ref="stock" data-placeholder="请选择仓库" disabled>
					</select>
				</div>
				<label class="list-label-3">供应商:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" ref="supplier" data-placeholder="请选择供应商">
					</select>
				</div>
			</div>
			<div class="row">
				<label class="list-label-2">类型:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" ref="purc_type">
						<option value="">全部</option>
						<option value="1">采购</option>
						<option value="2">赠送</option>
						<option value="3">盈余</option>
						<option value="4">换货</option>
						<option value="5">客遗</option>
					</select>
				</div>
				<div class="pull-right">
					<button type="button" class="btn btn-flat btn-small btn-orange" @click="queryList">查询</button>
				</div>
			</div>
			<div class="table-responsive">
				<table class="table table-bordered table-hover" data-pagination="true" ref="purchaselist"></table>
			</div>
		</div>
		<!-- detail -->
		<div class="purchasing-det" v-show="showdetail">
			<div class="row row-margin">
				<button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backList">返回</button>
				<div class="pull-right" v-show="modify == '1'||modify == '2'">
					<button type="button" class="btn btn-flat btn-middle btn-orange" @click="addGoods">添加商品</button>
					<button type="button" class="btn btn-flat btn-middle btn-orange" id="purcSave" @click="submitPurchase" v-show="modify=='1'">保存</button>
				</div>
				<div class="pull-right" v-show="modify != '1'">
					<button type="button" class="btn btn-flat btn-middle btn-orange" @click="saveSupplier" v-if="theDetail.type=='5'&&modify=='2'">保存</button>
					<button type="button" class="btn btn-flat btn-middle btn-orange" @click="setPageParams" v-if="theDetail.type=='5'">客遗详情</button>
					<button type="button" class="btn btn-flat btn-middle btn-orange" @click="innitPriceLog">操作日志</button>
					<button type="button" class="btn btn-flat btn-middle btn-orange" @click="getExportSet">导出</button>
				</div>
			</div>
			<div class="gray-head">
				<div class="page-title">{{pagetitle}}</div>
				<div class="comment">
					注释：采购进货单是商品从供应商进货入库到门店<br />
					商品数量支持乘法输入。例如输入12*3，系统自动算出等于36
				</div>
				<div class="row row-margin">
					<label class="col-md-1" v-show="showNumandTime">单号：</label>
					<span class="col-md-2" v-show="showNumandTime">{{theDetail.number}}</span>
					<label class="col-md-1">进货总额：</label>
					<span class="col-md-2">{{theDetail.amount | formateMoney}}</span>
					<label class="col-md-1">供&nbsp;&nbsp;应&nbsp;&nbsp;商：</label>
					<div class="col-md-2 ct-col">
						<select class="form-control" data-placeholder="请选择供应商" ref="edit_supplier">
							<option value=""></option>
						</select>
					</div>
					<label class="col-md-1">类&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;型：</label>
					<div class="col-md-2 ct-col">
						<select class="form-control" ref="edit_purc_type">
							<option value="1">采购</option>
							<option value="2">赠送</option>
							<option value="3">盈余</option>
							<option value="4">换货</option>
							<option value="5">客遗</option>
						</select>
					</div>
				</div>
				<div class="row">
					<label class="col-md-1" v-show="showNumandTime">时间：</label>
					<span class="col-md-2" v-show="showNumandTime">{{theDetail.create_time}}</span>
					<label class="col-md-1">门&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;店：</label>
					<div class="col-md-2 ct-col">
						<select class="form-control" ref="edit_shop" data-placeholder="请选择门店" disabled>
						</select>
					</div>
					<label class="col-md-1 control-label">仓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;库：</label>
					<div class="col-md-2 ct-col">
						<select class="form-control" ref="edit_stock" data-placeholder="请选择仓库" disabled>
						</select>
					</div>
					<label class="col-md-1">备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注：</label>
					<div class="col-md-2">
						<textarea class="form-control" placeholder="请输入备注" v-model="purc_remark" ref="purc_remark" @blur="onRemarkBlur"></textarea>
					</div>
				</div>
			</div>
			<div class="table-responsive">
				<table class="table table-bordered table-hover" data-pagination="true" ref="detaillist"></table>
			</div>
			<!-- 导出设置弹窗 -->
			<div class="ele-hide" ref="export_alert">
				<div class="set-export sel-seldiv">
					<h3>请选择导出报表需要的显示的字段</h3>
					<ul class="set-area clearfix">
						<li>
							<input type='checkbox' v-model='export_allcheck' @click='exportCheckedAll'>
							<label>全选</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="goods_name">
							<label>商品名称</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="goods_unit_name">
							<label>商品单位</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="goods_type_name">
							<label>商品类型</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="quantity">
							<label>商品数量</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="contract_amount">
							<label>进货合同价</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="amount">
							<label>进货单价</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="amount_total">
							<label>进货价合计</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="remark">
							<label>备注</label>
						</li>
					</ul>
					<h3>请选择导出报表的文件格式</h3>
					<ul class="clearfix">
						<li>
							<input type="radio" v-model='export_type' value="1">
							<label>excel表格</label>
						</li>
						<li>
							<input type="radio" v-model='export_type' value="2">
							<label>pdf文件</label>
						</li>
					</ul>
				</div>
			</div>

			<!-- pop -->
			<div class="add-goods" ref="addgoods">
				<el-radio-group v-model="pop_add_radio">
				    <el-radio :label="1">按商品</el-radio>
				    <el-radio :label="2">按商品分类</el-radio>
				</el-radio-group>
				<div class="by-goods" v-show="pop_add_radio=='1'">
					<div class="row">
						<div class="col-md-3 ct-col clear-pd">
							<select class="form-control" data-placeholder="商品类型" ref="goodtype">
								<option value=""></option>
							</select>
						</div>
						<div class="col-md-6">
							<input type="text" class="form-control" placeholder="请输入商品名称" ref="goodname" @keyup.13="queryGoods" />
						</div>
						<div class="pull-right">
							<button type="button" class="btn btn-flat btn-small btn-orange" @click="queryGoods">查询</button>
						</div>
					</div>
					<div class="table-responsive">
						<table class="table table-bordered table-hover" data-pagination="true" ref="goodslist"></table>
					</div>
					<div class="row btns">
						<button type="button" class="btn btn-flat btn-small btn-orange pop-save" @click="saveGoods">保存</button>
						<button type="button" class="btn btn-flat btn-small btn-gray" @click="closeLayer">取消</button>
					</div>
				</div>
				<div class="by-types" v-show="pop_add_radio=='2'">
					<div class="checkbox-wrapper">
			            <el-checkbox v-model="checkAllGoodsType" @change="handleCheckAllChange">全选</el-checkbox>
			            <el-checkbox-group v-model="choosed_goods_type" @change="handleCheckedGoodsTypeChange">
			                <el-checkbox v-for="item in goods_type_list" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
			            </el-checkbox-group>
					</div>
					<div class="row btns">
						<button type="button" class="btn btn-flat btn-small btn-orange pop-save" @click="onGoodsTypeSaveClick">保存</button>
						<button type="button" class="btn btn-flat btn-small btn-gray" @click="closeLayer">取消</button>
					</div>
				</div>
			</div>
		</div>
		<!-- 进货单价变动记录 -->
		<div class="price-change" ref="price_change">
			<table class="table table-bordered table-hover" data-pagination="true" ref="price_change_list"></table>
		</div>
		<!-- 操作日志 -->
		<div class="price-log" v-show="logPage">
			<div class="row">
				<button type="button" class="btn btn-flat btn-middle btn-orange" @click="backDetail">返回</button>
			</div>
			<div class="table-responsive">
				<table class="table table-bordered table-hover" data-pagination="true" ref="logList"></table>
			</div>
		</div>

	</div>
</template>

<script>
	import Vue from 'vue';
	export default {
		name: 'purchasing',
		data() {
			return {
				showdetail: false, //控制采购进货详情页显示
				showNumandTime: false, //控制详情页单号和时间的显示
				modify: '',
				preshopid: "", // 下拉框上次选中值
				presupplierid: "",
				pagetitle: "",
				startTime: "",
				endTime: "",
				shop: {
					value: []
				},
				theDetail: { //
					type: Object
				},
				purchase_list: [],
				detail_list: [],
				goodsType_list: [],
				stores: [],

				price_id: '',
				logPage: false,

				export_allcheck: false,
				c_export_allcheck: false,
				export_checkModel: [],
				export_checkData: ['goods_name', 'goods_unit_name', 'goods_type_name', 'quantity', 'contract_amount', 'amount', 'amount_total', 'remark'],
				export_type: 1,
				purc_remark: '',
				purc_menu_limit: [],
				cur_goods_id: '',
				or_kyjs_report_menu: {},

				pop_add_radio: 1,
				goods_type_list: [],
				checkAllGoodsType: false,
				choosed_goods_type: [], // 选中的商品类型
			}
		},
		computed: {
            menunew() {
                return JSON.parse(this.$store.state.menunew)
            },
        },
		watch: {
			'$route': {
				handler: function(val, oldVal) {
					if(val.params.purc_id) {
						this.modify = '2';
						this.getEditStock(val.params.purc_shop_id, val.params.purc_id);
					}
				},
				deep: true
			},

			export_checkModel: {
				handler: function(val, oldVal) {
					if(this.export_checkModel.length >= this.export_checkData.length) {
						this.export_allcheck = true;
						this.c_export_allcheck = true;
					} else {
						this.export_allcheck = false;
						this.c_export_allcheck = false;
					}
				},
				deep: true
			},
		},
		created: function() {
			this.goods_buying_change = this.$store.state.privinfo.goods_buying_change
		},
		mounted: function() {
			let _this = this;

			// 第一次打开
			if(_this.$route.params.purc_id) {
				_this.modify = '2';
				_this.getEditStock(_this.$route.params.purc_shop_id, _this.$route.params.purc_id);
			}

			_this.menu();
			this.$nextTick(function() {
				// 日期
				var myDate = new Date();
				this.IntstartTime = myDate;
				this.IntendTime = new Date(myDate.getTime() + 1 * 24 * 3600 * 1000);
				this.IntstartTime.setHours(8, 0);
				this.IntendTime.setHours(8, 0);
				var timStar = new Date(this.IntstartTime),
					year = timStar.getFullYear(),
					month = (timStar.getMonth() + 1) < 10 ? '0' + (timStar.getMonth() + 1) : (timStar.getMonth() + 1),
					day = timStar.getDate() < 10 ? '0' + timStar.getDate() : timStar.getDate(),
					hour = timStar.getHours() < 10 ? '0' + timStar.getHours() : timStar.getHours(),
					minute = timStar.getMinutes() < 10 ? '0' + timStar.getMinutes() : timStar.getMinutes();
				var timEnd = new Date(this.IntendTime),
					yearend = timEnd.getFullYear(),
					monthend = (timEnd.getMonth() + 1) < 10 ? '0' + (timEnd.getMonth() + 1) : (timEnd.getMonth() + 1),
					dayend = timEnd.getDate() < 10 ? '0' + timEnd.getDate() : timEnd.getDate(),
					hourend = timEnd.getHours() < 10 ? '0' + timEnd.getHours() : timEnd.getHours(),
					minuteend = timEnd.getMinutes() < 10 ? '0' + timEnd.getMinutes() : timEnd.getMinutes();
				this.startTime = year + '-' + month + '-' + day + ' ' + hour + ':' + minute;
				this.endTime = yearend + '-' + monthend + '-' + dayend + ' ' + hourend + ':' + minuteend;
				this.innitDate();
				this.getShop();
				this.innitSupplierInput(); // 初始化供应商输入框
				$(this.$refs.purc_type).select2({
					language: "zh-CN",
					minimumResultsForSearch: -1
				});
				$(this.$refs.edit_purc_type).select2({
					language: "zh-CN",
					minimumResultsForSearch: -1,
					width: '100%'
				}).on("select2:select", function(e) {
					for(let i = 0; i < _this.detail_list.length; i++) {
						_this.detail_list[i].amount = '0.00';
						_this.detail_list[i].amount_total = '0.00';
					}
					_this.innitDetailTable();
					// 更新价格
					_this.updatePrice();
				});
			});
			this.init_box('');
		},
		filters: {
			formateMoney: function(value) {
				if(value < 0) {
					return "0";
				} else {
					return value;
				}
			}
		},
		methods: {
			// 获取权限
			menu() {
				let _this = this,
					menu = {};
				if(!$.isEmptyObject(this.$store.state.menunew)) {
					menu = JSON.parse(this.$store.state.menunew);
					$.each(menu, function(k, v) {
						if(v.id == '543') {
							menu = v.submenu;
							$.each(menu, function(m, n) {
								if(n.name == '采购进货') {
									menu = n.submenu;
									$.each(menu, function(x, y) {
										if(y.id == '755') {
											_this.purc_menu_limit.push({cls: 'text-blue detail', name: '详情'});
										}
										if(y.id == '756') {
											_this.purc_menu_limit.push({cls: 'text-blue edit', name: '修改'});
										}
										if(y.id == '757') {
											_this.purc_menu_limit.push({cls: 'text-blue del', name: '删除'});
										}
									});
								}
							});
						}
						if (v.id == '544') {
							menu = v.submenu;
							$.each(menu, function(m, n) {
								if (n.name == '其它报表') {
									menu = n.submenu
									$.each(menu, function(x, y) {
										if (y.id == '1203') { // 客遗酒水回收入库报表
											_this.or_kyjs_report_menu = y
										}
									})
								}
							})
						}
					});
				}
			},
			// 跳转参数
            setPageParams() {
                const obj = {
                    name: 'or_kyjs_report',
                    params: {
                        guest_leave_id: this.theDetail.guest_leave_id
                    }
                }
                this.$emit("pageLink", this.or_kyjs_report_menu, obj)
            },

			// 相差几小时
			getPurHours: function(start, end) {
				var ms = end.getTime() - start.getTime();
				if(ms < 0) return 0;
				return Math.floor(ms/1000/60/60);
			},
			// 初始化日期
			innitDate: function() {
				let _this = this;
				$(_this.$refs.time).daterangepicker({
					timePicker: true,
					timePickerIncrement: 1,
					timePicker12Hour: false,
					buttonClasses: ['btn btn-default'],
					applyClass: 'btn-small btn-orange',
					cancelClass: 'btn-small btn-gray',
					startDate: _this.IntstartTime,
					endDate: _this.IntendTime
				}, function(start, end, label) {
					_this.startTime = start.format('YYYY-MM-DD HH:mm');
					_this.endTime = end.format('YYYY-MM-DD HH:mm');
				});
				// 取消按钮
				$(_this.$refs.time).on('cancel.daterangepicker', function(ev, picker) {
					_this.startTime = "";
					_this.endTime = "";

				});
			},
			// 清空日期
			clearDate: function() {
				this.startTime = "";
				this.endTime = "";
			},
			// 门店数据
			getShop: function() {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {
							
						}
					},
					"comment": ""
				};
				datas = JSON.stringify(datas);
				$.ajax({
					type: "POST",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: datas,
					success: function(data) {
						if(data['response']['result_code'] == "true") {
							let arr = [];
							$.each(data.response.result, function(k, v) {
								if (v.id != '0') {
									arr.push({ id: v.id, text: v.name });	
								}
							});
							$(_this.$refs.shop).select2({
								data: arr,
								allowClear: true,
								minimumResultsForSearch: -1,
								language: "zh-CN",
								width: '100%'
							}).on("select2:select", function(e) {
								if(e.params.data.text == "全部") {
									_this.init_box('');
									$(_this.$refs.stock).prop("disabled", true);
									return;
								}
								$(_this.$refs.stock).prop("disabled", false);
								_this.getStock(e.params.data.id);
							});
							$(_this.$refs.shop).val(data.response.result[1].id).trigger('change');
							$(_this.$refs.stock).prop("disabled", false);
							_this.getStock(data.response.result[1].id);
							_this.innitTable();

							// arr.shift();
							$(_this.$refs.edit_shop).select2({
								data: arr,
								minimumResultsForSearch: -1,
								language: "zh-CN",
								width: '100%'
							}).on("select2:select", function(e) {
								// _this.getEditStock(e.params.data.id);
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data["response"]["error_msg"]);
						}
					},
					error: function(err) {
						layer.msg('网络错误');
					}
				});
			},
			// 仓库数据
			getStock: function(shop_id) {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"shop_id": shop_id
						}
					},
					"comment": ""
				};
				datas = JSON.stringify(datas);
				$.ajax({
					type: "POST",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getStoreList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: datas,
					success: function(data) {
						if(data['response']['result_code'] == "true") {
							let arr = [{ id: " ", text: "全部" }];
							$.each(data['response']['result'], function(k, v) {
								arr.push({ id: v.id, text: v.name });
							});
							_this.init_box(arr);
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data["response"]["error_msg"]);
						}
					},
					error: function(err) {
						layer.msg('网络错误');
					}
				});
			},
			init_box: function(arr) {
				$(this.$refs.stock).html("");
				$(this.$refs.stock).select2({
					data: arr,
					minimumResultsForSearch: -1,
					language: "zh-CN",
					width: '100%'
				});
			},
			// 初始化供应商
			innitSupplierInput: function() {
				let _this = this;
				
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": "0",
							"page_size": "0"
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getSupplier",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							let arr = [{ id: "0", text: "全部" }];
							$.each(data.response.result.data.rows, function(k, v) {
								arr.push({ id: v.id, text: v.name });
							});
							$(_this.$refs.supplier).select2({
								data: arr,
								width: '100%'
							});
							
							arr.shift();
							$(_this.$refs.edit_supplier).select2({
								data: arr,
								width: '100%'
							});
							$(_this.$refs.edit_supplier).on("select2:select", function(e) {
								let id = e.params.data.id;
								if(_this.detail_list.length > 0) { // 已选择商品
									if (_this.theDetail.type == '5') { // 客遗类型
										_this.presupplierid = id;
									}else {
										layer.confirm('修改供应商，上次添加商品数据将不保存，确定修改？', {
											btn: ['确定', '取消'], // 按钮
											title: ['提示', true]
										}, function() {
											layer.closeAll();
											_this.detail_list = [];
											$(_this.$refs.detaillist).bootstrapTable('destroy');
											_this.presupplierid = id;
										}, function() {
											layer.closeAll();
											$(_this.$refs.edit_supplier).select2("val",[_this.presupplierid]);
											return;
										});
									}
								} else {
									_this.presupplierid = id;
								}
							});
							$(_this.$refs.edit_shop).on("select2:select", function (e) {
								let id = e.params.data.id;
								if(_this.detail_list.length > 0) {
									layer.confirm('修改门店，上次添加商品数据将不保存，确定修改？', {
										btn: ['确定', '取消'], //按钮
										title: ['提示', true]
									}, function() {
										layer.closeAll();
										_this.detail_list = [];
										$(_this.$refs.detaillist).bootstrapTable('destroy');
										_this.preshopid = id;
										_this.getEditStock(_this.preshopid);
									}, function() {
										layer.closeAll();
										$(_this.$refs.edit_shop).select2("val",[_this.preshopid]);
										_this.getEditStock(_this.preshopid);
										return;
									});
								} else {
									_this.preshopid = id;
									_this.getEditStock(_this.preshopid);
								}
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 列表
			innitTable: function() {
				let _this = this;
				$(_this.$refs.purchaselist).bootstrapTable("destroy");
				$(_this.$refs.purchaselist).bootstrapTable({
					pageNumber: 1,
					pageSize: 15,
					pageList: [],
					pagination: true,
					ajax: function(params) {
						_this.getPurchaseList(params);
					},
					sidePagination: "server",
					columns: [{
						field: "number",
						title: "进货单号",
						width: "15%"
					}, {
						field: "create_time",
						title: "进货日期",
						width: "15%"
					}, {
						field: "shop_name",
						title: "门店",
						width: "10%"
					}, {
						field: "store_name",
						title: "仓库",
						width: "5%"
					}, {
						field: "supplier_name",
						title: "供应商",
						width: "13%"
					}, {
						field: "quantity",
						title: "进货数量",
						width: "5%"
					}, {
						field: "amount",
						title: "进货总额",
						width: "8%"
					}, {
						field: "type",
						title: "类型",
						width: "6%",
						formatter: function(value, row, index) {
							if(row.type == '1') {
								return '采购';
							} else if(row.type == '2') {
								return '赠送';
							} else if(row.type == '3') {
								return '盈余';
							} else if(row.type == '4') {
								return '换货';
							} else if(row.type == '5') {
								return '客遗';
							}
						}
					}, {
						field: "admin_name",
						title: "操作人",
						width: "8%"
					}, {
						title: "操作",
						width: "13%",
						events: {
							'click .detail': function(e, value, row) {
								_this.modify = '3';
								_this.pagetitle = "采购进货单详情";
								_this.getEditStock(row.shop_id, row.id);
							},
							'click .edit': function(e, value, row) {
								_this.modify = '2';
								_this.pagetitle = "修改采购进货单";
								if(_this.getPurHours(new Date(row.create_time), new Date()) >= '48') {
									layer.msg('进货单已超过48小时，无法修改');
								} else {
									_this.getEditStock(row.shop_id, row.id);
								}
							},
							'click .del': function(e, value, row) {
								if(_this.getPurHours(new Date(row.create_time), new Date()) >= '48') {
									layer.msg('进货单已超过48小时，无法删除');
								} else {
									layer.confirm('删除后不可恢复，确定删除吗？', {
										btn: ['确定', '取消']
									}, function() {
										_this.delPurchasing(row.id);
									});
								}
							}
						},
						formatter: function(value, row, index) {
							let op_html = '';
							$.each(_this.purc_menu_limit, function(k, v) {
								op_html += '<span class="'+ v.cls +'">'+ v.name +'</span>';
							});
							return op_html;
						}
					}],
					data: _this.purchase_list
				});
			},
			// 获取采购入库列表
			getPurchaseList: function(params) {
				let _this = this,
					pageNumber = 1;
				if(params.data.offset != 0) {
					pageNumber = parseFloat(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit,
							"start_time": _this.startTime,
							"end_time": _this.endTime,
							"shop_id": $(_this.$refs.shop).val(),
							"store_id": $.trim($(_this.$refs.stock).val()),
							"supplier_id": $(_this.$refs.supplier).val(),
							"type": $(_this.$refs.purc_type).val()
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "stock/searchPurchaseInList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							params.success({
								total: data.response.result.data.total,
								rows: data.response.result.data.rows
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
							params.success({
								total: 0,
								rows: 0
							});
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 删除
			delPurchasing: function(id) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"id": id,
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				layer.load(0, {
					shade: [0.1, '#ececec'] // 0.1透明度的白色背景
				});
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "stock/delPurchaseIn",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						layer.closeAll();
						if(data.response.result_code == "true") {
							layer.msg(data.response.error_msg);
							$(_this.$refs.purchaselist).bootstrapTable('refresh');
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.closeAll();
						layer.msg("出错啦");
					}
				});
			},
			// 点击“查询”按钮
			queryList: function() {
				this.innitTable();
			},
			// 点击“新增采购进货单”
			addPurchase: function() {
				let _this = this;

				_this.modify = '1';
				_this.pagetitle = "新增采购进货单";
				_this.showNumandTime = false;

				_this.$set(_this.theDetail, 'amount', '0');
				$(_this.$refs.edit_supplier).val("").trigger("change");
				$(_this.$refs.edit_supplier).prop("disabled", false);
				$(_this.$refs.edit_purc_type).val("").trigger("change");
				$(_this.$refs.edit_purc_type).prop("disabled", false);
				$(_this.$refs.edit_shop).val('').trigger("change");
				$(_this.$refs.edit_shop).prop("disabled", false);
				_this.getEditStock($(_this.$refs.edit_shop).val());
				$(_this.$refs.edit_stock).prop("disabled", false);
				_this.purc_remark = '';
				$(_this.$refs.purc_remark).prop("disabled", false);

				_this.detail_list = [];
				$(_this.$refs.detaillist).bootstrapTable('destroy');
				// _this.theDetail = {};

				_this.showdetail = true;
			},
			// 仓库
			getEditStock: function(shop_id, id) {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"shop_id": shop_id
						}
					},
					"comment": ""
				};
				datas = JSON.stringify(datas);
				$.ajax({
					type: "POST",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getStoreList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: datas,
					success: function(data) {
						if(data['response']['result_code'] == "true") {
							_this.stores = []
							// let arr = [];
							$.each(data['response']['result'], function(k, v) {
								_this.stores.push({ id: v.id, text: v.name });
							});
							
							if(_this.modify != '1') {
								_this.getDetail(id);
							}else {
								$(_this.$refs.edit_stock).html("");
								$(_this.$refs.edit_stock).select2({
									data: _this.stores,
									minimumResultsForSearch: -1,
									language: "zh-CN",
									width: '100%'
								});
							}
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data["response"]["error_msg"]);
						}
					},
					error: function(err) {
						layer.msg('网络错误');
					}
				});
			},
			// 获取采购入库单详情
			getDetail: function(id) {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"id": id,
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				layer.load(0, {
					shade: [0.1, '#ececec'] //0.1透明度的白色背景
				});
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "stock/getPurchaseInDetail",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						layer.closeAll();
						if(data.response.result_code == "true") {
							_this.price_id = data.response.result.data.id;
							_this.theDetail = data.response.result.data;
							_this.detail_list = data.response.result.data.goods;
							_this.innitDetailTable();
							$(_this.$refs.purc_remark).prop("disabled", false);
							if(_this.modify == '3') {
								$(_this.$refs.detaillist).bootstrapTable('hideColumn', 'op'); // 隐藏操作列
								$(_this.$refs.purc_remark).prop("disabled", true); // 备注
							}
							// 供应商
							if (_this.modify == '2' && _this.theDetail.type == '5') {
								$(_this.$refs.edit_supplier).val(data.response.result.data.supplier_id).trigger("change");
								$(_this.$refs.edit_supplier).prop("disabled", false);
							}else {
								$(_this.$refs.edit_supplier).val(data.response.result.data.supplier_id).trigger("change");
								$(_this.$refs.edit_supplier).prop("disabled", true);
							}
							// 类型
							$(_this.$refs.edit_purc_type).val(data.response.result.data.type).trigger("change");
							$(_this.$refs.edit_purc_type).prop("disabled", true);
							// 门店
							$(_this.$refs.edit_shop).val(data.response.result.data.shop_id).trigger("change");
							$(_this.$refs.edit_shop).prop("disabled", true);
							// 仓库
							if(_this.checkStoreIsExist(data.response.result.data.store_id)) {
								$(_this.$refs.edit_stock).html("");
								$(_this.$refs.edit_stock).select2({
									data: _this.stores,
									minimumResultsForSearch: -1,
									language: "zh-CN",
									width: '100%'
								});
								$(_this.$refs.edit_stock).val(data.response.result.data.store_id).trigger("change");
							}else {
								let tempArr = [].concat( _this.stores)
								tempArr.unshift({
									id: '-1',
									text: data.response.result.data.store_name
								})
								$(_this.$refs.edit_stock).html("");
								$(_this.$refs.edit_stock).select2({
									data: tempArr,
									minimumResultsForSearch: -1,
									language: "zh-CN",
									width: '100%'
								});
								$(_this.$refs.edit_stock).val('-1').trigger("change");
							}
							$(_this.$refs.edit_stock).prop("disabled", true);
							// 备注
							_this.purc_remark = data.response.result.data.remark;

							_this.showNumandTime = true;
							_this.showdetail = true;
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.closeAll();
						layer.msg("出错啦");
					}
				});
			},

			// 检查仓库是否健在
			checkStoreIsExist(store_id) {
				let store_ids = []
				this.stores.forEach(item => {
					store_ids.push(item.id)
				})
				return store_ids.includes(store_id)
			},

			// 初始化采购进详情列表
			innitDetailTable: function(pageNumber) {
				let _this = this;
				let actionEvents = {
					'click .delete': function(e, value, row, index) {
						layer.confirm("确定删除该商品吗？", {
							btn: ['确定', '取消'], // 按钮
						}, function() {
							if(_this.modify != '1') {
								_this.delDetPurchas(row.id);
							}
							let depositeData = [];
							for(let i = 0; i < _this.detail_list.length; i++) {
								if(_this.detail_list[i].merchant_goods_id != row.merchant_goods_id) {
									depositeData.push(_this.detail_list[i]);
								}
							}
							_this.detail_list = depositeData;

							// 刷新滚动条不变
							let scollPostion = $('.tab-content').scrollTop();
							_this.innitDetailTable($(_this.$refs.detaillist).bootstrapTable('getOptions').pageNumber);
							$('.tab-content').scrollTop(scollPostion);

							layer.closeAll();
							_this.updatePrice();
						});

					},
					'click .editableicon': function(e, value, row, index) {
						$(this).prev().addClass("editableinput-focus");
						$(this).prev().attr("contenteditable", true);
						$(this).addClass("editableiconend");
						$(this).prev().focus();
					},
					'click .price-change-log': function(e, value, row, index) {
						// 进货单价变动记录
						_this.cur_goods_id = row.merchant_goods_id;
						_this.showPriceChange();
					},
					'keypress .editableinput': function(e, value, row, index) {
						if(event.keyCode == "13") {
							$(this).blur();
						}
					},
					'blur .editableinput': function(e, value, row, index) {
						$(this).removeClass("editableinput-focus");
						$(this).attr("contenteditable", false);
						$(this).next().removeClass("editableiconend");
						if($(e.target).hasClass("quantity") == true) {
							// 数量编辑
							let arr = $(this).text().split('*');
							let num = 1;
							$.each(arr, function(k, v) {
								num *= v;
							});
							num += '';
							if(isNaN(num)) {
								layer.msg("请输入数字");
								$(this).text(value);
								return;
							} else if(num <= 0) {
								layer.msg("数量需大于0");
								$(this).text(value);
								return;
							}
							if(num.split('.')[1] && num.split('.')[1].length > '2') {
								num = new Big(num).toFixed(2);
							}
							for(let i = 0; i < _this.detail_list.length; i++) {
								if(_this.detail_list[i].merchant_goods_id == row.merchant_goods_id) {
									_this.detail_list[i].quantity = num;
									_this.detail_list[i].amount_total = new Big(_this.detail_list[i].amount).times(new Big(num)).toString();
									if(_this.detail_list[i].amount_total.split('.')[1] && _this.detail_list[i].amount_total.split('.')[1].length > '6') {
										_this.detail_list[i].amount_total = new Big(_this.detail_list[i].amount_total).toFixed(6);
									}
									if(_this.modify != '1') {
										_this.editPurchas(row.id, num, _this.detail_list[i].amount, _this.detail_list[i].amount_total, row.remark);
									}
								}
							}
						} else if($(e.target).hasClass("amount") == true) {
							// 单价编辑
							if($(this).text() - 0 < 0) {
								layer.msg("价格不小于0");
								$(this).text(value);
							}
							if($(this).text().split('.')[1] && $(this).text().split('.')[1].length > '6') {
								$(this).text(new Big($(this).text()).toFixed(6));
							}
							for(let i = 0; i < _this.detail_list.length; i++) {
								if(_this.detail_list[i].merchant_goods_id == row.merchant_goods_id) {
									_this.detail_list[i].amount = $(this).text();
									_this.detail_list[i].amount_total = new Big($(this).text()).times(new Big(_this.detail_list[i].quantity)).toString();
									if(_this.detail_list[i].amount_total.split('.')[1] && _this.detail_list[i].amount_total.split('.')[1].length > '6') {
										_this.detail_list[i].amount_total = new Big(_this.detail_list[i].amount_total).toFixed(6);
									}
									if(_this.modify != '1') {
										_this.editPurchas(row.id, _this.detail_list[i].quantity, $(this).text(), _this.detail_list[i].amount_total, row.remark);
									}
								}
							}
						} else if($(e.target).hasClass("amount_total") == true) {
							// 进货价合计编辑
							if($(this).text() - 0 < 0) {
								layer.msg("价格不小于0");
								$(this).text(value);
							}
							if($(this).text().split('.')[1] && $(this).text().split('.')[1].length > '6') {
								$(this).text(new Big($(this).text()).toFixed(6));
							}
							for(let i = 0; i < _this.detail_list.length; i++) {
								if(_this.detail_list[i].merchant_goods_id == row.merchant_goods_id) {
									_this.detail_list[i].amount_total = $(this).text();
									// let amount = new Big($(this).text() / _this.detail_list[i].quantity).toString();
									// if(amount.split('.')[1] && amount.split('.')[1].length > '6') {
									// 	amount = new Big(amount).toFixed(6);
									// }
									// _this.detail_list[i].amount = amount;
									Big.DP = 6;
									_this.detail_list[i].amount = new Big($(this).text()).div(new Big(_this.detail_list[i].quantity));
									if(_this.modify != '1') {
										_this.editPurchas(row.id, _this.detail_list[i].quantity, _this.detail_list[i].amount, $(this).text(), row.remark);
									}
								}
							}
						}

						// 刷新滚动条不变
						let scollPostion = $('.el-tabs__content').scrollTop();
						console.log(scollPostion)
						$(_this.$refs.detaillist).bootstrapTable('refreshOptions', {});
						_this.$nextTick(() => {$('.el-tabs__content').scrollTop(scollPostion)});

						_this.updatePrice();
					},
				};
				$(_this.$refs.detaillist).bootstrapTable("destroy");
				$(_this.$refs.detaillist).bootstrapTable({
					pageNumber: pageNumber || 1,
					pageSize: 10,
					pageList: [],
					pagination: true,
					columns: [{
						field: "goods_name",
						title: "商品名称",
						width: "8%",
						valign: "middle"
					}, {
						field: "goods_unit_name",
						title: "商品单位",
						width: "5%",
						valign: "middle"
					}, {
						field: "goods_type_name",
						title: "商品类型",
						width: "5%",
						valign: "middle"
					}, {
						field: "quantity",
						title: "商品数量",
						width: "12%",
						valign: "middle",
						events: actionEvents,
						formatter: function(value) {
							if(_this.modify != '3') {
								return '<div class="editableinput quantity" contenteditable="false">' + value + '</div><a class="editableicon"></a>';
							} else {
								return value;
							}
						}
					}, {
						field: "contract_amount",
						title: "进货合同价",
						width: "6%",
						valign: "middle"
					}, {
						field: "amount",
						title: "进货单价",
						width: "12%",
						valign: "middle",
						events: actionEvents,
						formatter: function(value) {
							if(_this.modify != '3') {
								if (!!_this.goods_buying_change) {
									return '<div class="editableinput amount" contenteditable="false">' + value + '</div><a class="editableicon"></a><p class="price-change-log">变动记录</p>';
								}else {
									return '<div class="editableinput amount" contenteditable="false">' + value + '</div><p class="price-change-log">变动记录</p>';
								}
							} else {
								return value;
							}
						}
					}, {
						field: "amount_total",
						title: "进货价合计",
						width: "12%",
						valign: "middle",
						events: actionEvents,
						formatter: function(value, row, index) {
							if(_this.modify != '3') {
								if (!!_this.goods_buying_change) {
									return '<div class="editableinput amount_total" contenteditable="false">' + value + '</div><a class="editableicon"></a>';
								}else {
									return '<div class="editableinput amount_total" contenteditable="false">' + value + '</div></a>';
								}
							} else {
								return value;
							}
						}
					}, {
						field: "remark",
						title: "备注",
						width: "8%",
						events: {
							'blur .remark': function (e, value, row, index) {
								_this.detail_list[index].remark = $(this).val();
								if (_this.modify == '2') {
									_this.editPurchas(row.id, _this.detail_list[index].quantity, _this.detail_list[index].amount, _this.detail_list[index].amount_total, row.remark);
								}
							}
						},
						formatter: function(value, row, index) {
							if(_this.modify == '1' || _this.modify == '2') {
								return '<input type="text" placeholder="请输入备注" class="remark" value="'+ value +'" />';
							} else {
								return value;
							}
						}
					}, {
						field: "op",
						title: "操作",
						width: "6%",
						valign: "middle",
						events: actionEvents,
						formatter: function(value, row, index) {
							return '<span class="text-blue delete">删除</span>'
						}
					}],
					data: _this.detail_list
				});
			},
			// 点击“新增商品”
			addGoods: function() {
				let _this = this,
					shop_id = $(_this.$refs.edit_shop).val(),
					supplier_id = $(_this.$refs.edit_supplier).val();;

				if($(_this.$refs.edit_shop).val() == "") {
					layer.msg("请选择门店");
					return;
				} else if($(_this.$refs.edit_supplier).val() == '') {
					layer.msg("请选择供应商");
					return;
				}
				_this.innitSelect();
				_this.innitGoodsTable();
				_this.pop_add_radio = 1
				_this.checkAllGoodsType = false
				_this.choosed_goods_type = [] // 选中的商品类型
				layer.open({
					type: 1,
					title: '添加进货商品',
					skin: 'layui-layer-rim', // 加上边框
					area: ['820px', '600px'], // 宽高
					content: $(_this.$refs.addgoods)
				});
			},
			// 初始化添加进货商品弹窗的商品列表
			innitGoodsTable: function() {
				let _this = this;
				$(_this.$refs.goodslist).bootstrapTable('destroy');
				$(_this.$refs.goodslist).bootstrapTable({
					pageNumber: 1,
					pageSize: 5,
					pageList: [5,10,20,30,50,100],
					pagination: true,
					height: 350,
					ajax: function(params) {
						_this.getGoodsList(params);
					},
					sidePagination: "server",
					columns: [{
						checkbox: true,
						title: "全选"
					}, {
						field: "goods_type_name",
						title: "类型"
					}, {
						field: "goods_name",
						title: "名称"
					}, {
						field: "goods_unit_name",
						title: "单位"
					}],
					clickToSelect: true
				});
			},
			// 获取商品列表
			getGoodsList: function(params) {
				let _this = this,
					goods_type = $(_this.$refs.goodtype).val(),
					goods_name = $(_this.$refs.goodname).val(),
					pageNumber = 1;
				if(params.data.offset != 0) {
					pageNumber = parseFloat(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"shop_id": $(_this.$refs.edit_shop).val(),
							"goods_type": goods_type,
							"goods_name": goods_name,
							"recommend": "",
							"page": pageNumber,
							"page_size": params.data.limit,
							"all_sell": 1,
							"supplier_id": $(_this.$refs.edit_supplier).val(),
							"purchase_type": $(_this.$refs.edit_purc_type).val(),
							"api_type": "purchaseIn"
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);

				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "merchantGoods/searchMerchantGoodsList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							params.success({
								total: data.response.result.data.total,
								rows: data.response.result.data.rows
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			closeLayer: function() {
				layer.closeAll();
				this.clearPop();
			},
			// 清空弹窗的值
			clearPop: function() {
				$(this.$refs.goodtype).val("");
				$(this.$refs.goodname).val("");
				$(this.$refs.goodslist).bootstrapTable("destroy");
			},
			// 初始化商品类型选择框
			innitSelect: function() {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);

				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getGoodsType",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							_this.goodsType_list.push({
								id: "0",
								text: "全部"
							});
							$.each(data.response.result.data, function(k, v) {
								_this.goodsType_list.push({
									id: v.id,
									text: v.name
								});
							});
							$(_this.$refs.goodtype).select2({
								allowClear: true,
								data: _this.goodsType_list
							});
							_this.goods_type_list = data.response.result.data
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},

			// 点击新增进货商品弹窗的“查询”按钮
			queryGoods: function() {
				this.innitGoodsTable();
			},
			// 点击新增进货商品弹窗的“保存”按钮
			saveGoods: function() {
				let _this = this;
				let add_goods = []
				$.map($(_this.$refs.goodslist).bootstrapTable('getSelections'), function(row) {
					for(let i = 0; i < _this.detail_list.length; i++) {
						if(_this.detail_list[i].merchant_goods_id == row.id) {
							layer.msg("商品已存在");
							return;
						}
					}
					if($(_this.$refs.edit_purc_type).val() == '2') {
						_this.detail_list.push({ merchant_goods_id: row.id, goods_name: row.goods_name, goods_type_name: row.goods_type_name, goods_unit_name: row.goods_unit_name, quantity: "1", contract_amount: row.contract_amount, amount: 0, amount_total: 0, remark: '' });
						add_goods.push({merchant_goods_id: row.id, goods_name: row.goods_name, goods_type_name: row.goods_type_name, goods_unit_name: row.goods_unit_name, quantity: "1", contract_amount: row.contract_amount, amount: 0, amount_total: 0, remark: '' })
					} else {
						_this.detail_list.push({ merchant_goods_id: row.id, goods_name: row.goods_name, goods_type_name: row.goods_type_name, goods_unit_name: row.goods_unit_name, quantity: "1", contract_amount: row.contract_amount, amount: row.purchase_amount, amount_total: row.purchase_amount, remark: '' });
						add_goods.push({merchant_goods_id: row.id, goods_name: row.goods_name, goods_type_name: row.goods_type_name, goods_unit_name: row.goods_unit_name, quantity: "1", contract_amount: row.contract_amount, amount: row.purchase_amount, amount_total: row.purchase_amount, remark: '' })
					}
					layer.msg("成功添加商品");
				});
				if (_this.modify == '2' && add_goods.length > 0) {
					_this.onEditPageAddGoods(add_goods)
				}
				_this.innitDetailTable($(_this.$refs.detaillist).bootstrapTable('getOptions').pageNumber);
				// 更新价格
				_this.updatePrice();
			},
			// 更新进货总价
			updatePrice: function() {
				let _this = this;
				let totalPrice = 0;
				if(typeof($(_this.$refs.detaillist).bootstrapTable("getData")) == 'undefined') {
					_this.theDetail.amount = totalPrice;
					return;
				}
				$.each($(_this.$refs.detaillist).bootstrapTable("getData"), function(i, item) {
					totalPrice = new Big(item.amount_total).plus(totalPrice);
				});
				_this.$set(_this.theDetail, 'amount', totalPrice);
			},
			// 点击“全选”商品类型
			handleCheckAllChange(val) {
                this.choosed_goods_type = []
                if (!!val) {
                    this.goods_type_list.forEach(item => {
                        this.choosed_goods_type.push(item.id)
                    })
                }
            },
            // 选择商品类型
            handleCheckedGoodsTypeChange(value) {
                let checkedCount = value.length;
                this.checkAllGoodsType = checkedCount === this.goods_type_list.length;
            },
            // 商品类型选择“保存”
            onGoodsTypeSaveClick() {
            	if (this.choosed_goods_type.length < 1) {
            		layer.msg("请先选择商品类型！")
            		return
            	}
            	this.getGoodsByTypeArr(this.choosed_goods_type)
            },
            // 根据商品类型数组获取全部商品
            getGoodsByTypeArr(type_arr) {
            	let _this = this
            	let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"shop_id": $(_this.$refs.edit_shop).val(),
							"goods_type": '',
							"goods_name": '',
							"goods_type_arr": type_arr,
							"recommend": "",
							"page": 0,
							"page_size": 0,
							"all_sell": 1,
							"supplier_id": $(_this.$refs.edit_supplier).val(),
							"purchase_type": $(_this.$refs.edit_purc_type).val(),
							"api_type": "purchaseIn"
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);

				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "merchantGoods/searchMerchantGoodsList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							let res = data.response.result.data.rows
							let add_goods = []
							$.map(res, function(row) {
								for(let i = 0; i < _this.detail_list.length; i++) {
									if(_this.detail_list[i].merchant_goods_id == row.id) {
										layer.msg("商品已存在");
										return;
									}
								}
								if($(_this.$refs.edit_purc_type).val() == '2') {
									_this.detail_list.push({ merchant_goods_id: row.id, goods_name: row.goods_name, goods_type_name: row.goods_type_name, goods_unit_name: row.goods_unit_name, quantity: "1", contract_amount: row.contract_amount, amount: 0, amount_total: 0, remark: '' });
									add_goods.push({merchant_goods_id: row.id, goods_name: row.goods_name, goods_type_name: row.goods_type_name, goods_unit_name: row.goods_unit_name, quantity: "1", contract_amount: row.contract_amount, amount: 0, amount_total: 0, remark: '' })
								} else {
									_this.detail_list.push({ merchant_goods_id: row.id, goods_name: row.goods_name, goods_type_name: row.goods_type_name, goods_unit_name: row.goods_unit_name, quantity: "1", contract_amount: row.contract_amount, amount: row.purchase_amount, amount_total: row.purchase_amount, remark: '' });
									add_goods.push({merchant_goods_id: row.id, goods_name: row.goods_name, goods_type_name: row.goods_type_name, goods_unit_name: row.goods_unit_name, quantity: "1", contract_amount: row.contract_amount, amount: row.purchase_amount, amount_total: row.purchase_amount, remark: '' })
								}
								layer.msg("成功添加商品");
							});
							if (_this.modify == '2' && add_goods.length > 0) {
								_this.onEditPageAddGoods(add_goods)
							}
							_this.innitDetailTable($(_this.$refs.detaillist).bootstrapTable('getOptions').pageNumber);
							// 更新价格
							_this.updatePrice();
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
            },

			// 提交采购进货单
			submitPurchase: function() {
				let _this = this,
					shop_id = $(_this.$refs.edit_shop).val(),
					store_id = "",
					supplier_id = $(_this.$refs.edit_supplier).val();
				if(shop_id == "") {
					layer.msg("请选择门店");
					return;
				} else if(supplier_id == '') {
					layer.msg("请选择供应商");
					return;
				} else if(_this.detail_list.length <= 0) {
					layer.msg("请添加商品");
					return;
				}
				if($(_this.$refs.edit_stock).select2("data").length > 0) {
					store_id = $(_this.$refs.edit_stock).select2("data")[0].id;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"shop_id": shop_id,
							"store_id": store_id,
							"supplier_id": supplier_id,
							"type": $(_this.$refs.edit_purc_type).val(),
							"amount": _this.theDetail.amount, // 总额
							"remark": _this.purc_remark,
							"goods": _this.detail_list
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				layer.load(0, {
					shade: [0.1, '#ececec'] // 0.1透明度的白色背景
				});
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "stock/addPurchaseIn",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						layer.closeAll();
						if(data.response.result_code == "true") {
							$('#purcSave').prop('disabled', true);
							layer.msg("新增成功！");
							// 显示时间和单号
							_this.$set(_this.theDetail, "number", data.response.result.data.number);
							_this.$set(_this.theDetail, "create_time", _this.getNowFormatDate());
							_this.showNumandTime = true;
							$(_this.$refs.purchaselist).bootstrapTable("refresh");
							//返回列表页刷新列表
							setTimeout(function() {
								_this.showdetail = false;
								_this.showNumandTime = false;
								$('#purcSave').prop('disabled', false);
							}, 2000);
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.closeAll();
						layer.msg("出错啦");
					}
				});
			},
			// 修改商品数量、商品单价
			editPurchas: function(id, quantity, amount, amount_total, remark) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"id": id,
							"quantity": quantity,
							"amount": amount,
							"amount_total": amount_total,
							"remark": remark
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "stock/modifyPurchaseInDetail",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							layer.msg(data.response.error_msg);
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 删除详情页商品
			delDetPurchas: function(id) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"id": id
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "stock/delPurchaseInDetail",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							layer.msg(data.response.error_msg);
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 返回列表页
			backList: function() {
				this.showdetail = false;
				if(this.modify == '2') {
					$(this.$refs.purchaselist).bootstrapTable('refresh');
				}
			},
			// 获取当前时间
			getNowFormatDate: function() {
				var date = new Date();
				var seperator1 = "-";
				var seperator2 = ":";
				var month = date.getMonth() + 1;
				var strDate = date.getDate();
				if(month >= 1 && month <= 9) {
					month = "0" + month;
				}
				if(strDate >= 0 && strDate <= 9) {
					strDate = "0" + strDate;
				}
				var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate +
					" " + date.getHours() + seperator2 + date.getMinutes() +
					seperator2 + date.getSeconds();
				return currentdate;
			},
			// 获取导出设置
			getExportSet: function() {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"report_type": "stock/purchaseInExport"
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "FinanceReport/getExportSet",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							if(data.response.result) {
								_this.export_checkModel = data.response.result.export_fields;
								_this.export_type = data.response.result.export_type;
							} else {
								_this.export_checkModel = _this.export_checkData;
								_this.export_type = 1;
							}
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});

				// 弹窗
				layer.confirm('', {
					skin: 'add_printer_area',
					type: 1,
					btn: ['确定', '取消'], // 按钮
					title: ['导出设置', true],
					area: ['830px', ''], // 宽高
					content: $(_this.$refs.export_alert)
				}, function() {
					_this.exportDetail();
				});
			},
			// 导出字段全选
			exportCheckedAll: function() {
				let _this = this;
				_this.export_allcheck = _this.c_export_allcheck;
				if(!_this.export_allcheck) { // 实现全选
					_this.export_checkModel = [];
					_this.export_checkData.forEach(function(item) {
						_this.export_checkModel.push(item);
					});
				} else { // 实现反选
					_this.export_checkModel = [];
				}
			},
			// 导出
			exportDetail: function() {
				let export_fields = JSON.stringify(this.export_checkModel);
				window.location.href = Vue.ctUrl + "stock/purchaseInExport?" +
					"id=" + this.theDetail.id +
					"&export_fields=" + export_fields +
					"&export_type=" + this.export_type;
				layer.msg("导出成功！");
				layer.closeAll();
			},
			// 进货单价变动记录
			showPriceChange() {
				layer.open({
					type: 1,
					skin: 'public-alert-skin',
                    title: '进货单价变动记录',
                    area: ['600px', ''],
                    content: $(this.$refs.price_change)
                });
				this.initPriceChangeLog();
			},
			initPriceChangeLog: function() {
				let _this = this;
				$(_this.$refs.price_change_list).bootstrapTable('destroy');
				$(_this.$refs.price_change_list).bootstrapTable({
					pageNumber: 1,
					pageSize: 5,
					pageList: [],
					pagination: true,
					ajax: function(params) {
						_this.getPriceChangeList(params);
					},
					sidePagination: "server",
					columns: [{
						field: "create_time",
						title: "操作时间",
						width: "10%",
						valign: 'middle'
					}, {
						field: "buying_price",
						title: "进货单价",
						width: "10%",
						valign: 'middle'
					}]
				});
			},
			getPriceChangeList: function(params) {
				let _this = this,
					pageNumber = 1;
				if(params != "" && params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit,
							"shop_id": $(_this.$refs.edit_shop).val(),
							"goods_id": _this.cur_goods_id
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "MerchantGoods/getGoodsBuyingChangeLog",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							// if(pageNumber == '1') {
							// 	_this.rcw_list_total = data.response.result.total;
							// }
							params.success({
								total: data.response.result.total,
								rows: data.response.result.rows
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},

			// 初始化操作日志列表
			innitPriceLog: function() {
				let _this = this;
				$(_this.$refs.logList).bootstrapTable('destroy');
				$(_this.$refs.logList).bootstrapTable({
					pageNumber: 1,
					pageSize: 5,
					pageList: [],
					ajax: function(params) {
						_this.priceLog(params);
					},
					pagination: true,
					sidePagination: "server",
					columns: [{
						field: "log",
						title: "操作日志",
						align: 'left',
						formatter: function(value, row, index) {
							let goodsLog = '';
							$.each(row.goods, function(k, v) {
								goodsLog += '<li><span>'+ v.goods_name +'</span>进货价由<span>'+ v.old_amount +'</span>元改成<span>'+ v.new_amount +'</span>元</li>';
							});
							return '<div class="log-con">' +
										'<div>' +
											'<span>操作时间：'+ row.create_time +'</span>' +
											'<span>操作人：'+ row.admin_name +'</span>' +
										'</div>' +
										'<ul>'+ goodsLog +'</ul>' +
									'</div>';
						}
					}]
				});
			},
			// 操作日志数据
			priceLog: function(params) {
				let _this = this,
					pageNumber = 1;

				if(params.data.offset != 0) {
					pageNumber = parseFloat(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"id": _this.price_id,
							"page": pageNumber,
							"page_size": '5'
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				layer.load(0, {
					shade: [0.1, '#ececec'] // 0.1透明度的白色背景
				});
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "stock/getPurchaseInEditLog",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						layer.closeAll();
						if(data.response.result_code == "true") {
							params.success({
								total: data.response.result.total,
								rows: data.response.result.rows
							});
							// _this.priceLogData = data.response.result;
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
							params.success({
								total: 0,
								rows: []
							});
						}
						_this.logPage = true;
						$('.purchasing-det').hide();
					},
					error: function(err) {
						layer.closeAll();
						layer.msg("出错啦");
					}
				});
			},
			// 返回
			backDetail: function() {
				this.logPage = false;
				$('.purchasing-det').show();
			},

			// 保存供应商修改
			saveSupplier: function() {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"id": _this.theDetail.id,
							"supplier_id": $(_this.$refs.edit_supplier).val(),
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "Stock/editPurchaseIn",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							layer.msg("保存成功！");
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},

			// 修改备注
			onRemarkBlur() {
				if (this.modify == '2') {
					let _this = this;
					let datas = {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
								"id": _this.theDetail.id,
								"supplier_id": $(_this.$refs.edit_supplier).val(),
								"remark": _this.purc_remark, // 备注
							}
						},
						"comment": ""
					};
					let datas2 = JSON.stringify(datas);
					$.ajax({
						type: "post",
						dataType: "json",
						url: Vue.ctUrl + "Stock/editPurchaseIn",
						crossDomain: true,
						xhrFields: {
							withCredentials: true
						},
	                    data: datas2,
						success: function(data) {
							if(data.response.result_code == "true") {
								layer.msg("修改成功！");
							} else {
								Vue.timeoutfun(data.response.result_status, _this);
								layer.msg(data.response.error_msg);
							}
						},
						error: function(err) {
							layer.msg("出错啦");
						}
					});
				}
			},

			// 修改页面新增商品
			onEditPageAddGoods(goods) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"id": _this.theDetail.id,
							"supplier_id": $(_this.$refs.edit_supplier).val(),
							"remark": _this.purc_remark, // 备注
							"add_goods": goods
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "Stock/editPurchaseIn",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							_this.getDetail(_this.theDetail.id)
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
		}
	}
</script>

<style lang="less">
	.purchasing {
		.purchasing-det {
			.pull-right {
				button {
					margin: 0 0 0 30px;
				}
			}
			.gray-head {
				padding: 0 50px 20px;
				border-top: 8px solid #d7d7d7;
				background: #f3f3f3;
				.page-title {
					height: 30px;
					margin-top: 10px;
					line-height: 30px;
					font-size: 20px;
					text-align: center;
				}
				.comment {
					margin: 20px 0;
					line-height: 22px;
					font-size: 12px;
					color: #009af0;
					text-align: center;
				}
				.row {
					display: flex;
					flex-direction: row;
					align-items: center;
				}
				label {
					height: 32px;
					padding: 0;
					margin: 0 0 0;
					line-height: 32px;
					font-size: 14px;
					text-align: right;
				}
			}
			.title {
				height: 50px;
				line-height: 50px;
				font-size: 16px;
				text-align: center;
			}
			.add-goods {
				display: none;
				width: 100%;
				height: 100%;
				padding: 20px 30px;
				.btns {
					margin-top: 10px;
					.pop-save {
						margin: 0 50px 0 200px;
					}
				}
			}
			.price-change-log {
				clear: both;
				color: #009af0;
				cursor: pointer;
			}
		}
		.log-con {
			div {
				margin: 0 0 50px;
			}
			div span {
				margin: 0 100px 0 0;
			}
			ul span {
				color: #FF4773;
			}
			li {
				margin: 0 0 30px;
			}
		}
		.querytxt {
            padding-left: 0;
            margin: 2px 0 0 -36px;
        }
        .set-export {
            padding: 0 20px 20px;
            h3 {
                font-size: 16px;
            }
            li {
                float: left;
                width: 20%;
            }
        }
        .add-goods {
			.el-radio-group {
				margin-bottom: 15px;
			}
			.checkbox-wrapper {
				max-height: 350px;
				overflow-y: auto
			}
			.el-checkbox {
				width: 200px;
				margin: 10px;
			}
        }
	}
</style>